import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseB2BOffers } from "./UseB2BOffers";
import { UseMyPC } from "../../../hooks/UseMyPC";
import CustomPagination from "../../../components/CustomPagination";
import ProgressCom from "../../../components/ProgressCom";
import { toMoney } from "../../../util/Utils";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../components/DeleteRow";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export default function B2BOffers(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getOffersList, deleteOffer } = UseB2BOffers();
  const { myPc, setScrollTo, refresh } = UseMyPC();
  const [offerRes, setOfferRes] = useState();

  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    setProgress(true);
    getOffersList((offers) => {
      setOfferRes(offers);
    });
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("offer");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (location.state && location.state.panel) {
      const element = document.getElementById("offer");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [location.state]);

  const newFunc = () => {
    return navigate("/b2borders/addB2BOffer", {
      state: {
        model: offerRes,
        panel: "offer",
        search: props.search,
        state: props.state,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },

    {
      field: "description",
      headerName: "توضیحات",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="body2"
            sx={{ textAlign: "center", whiteSpace: "normal" }}
          >
            {cellValues.row.description}
          </Typography>
        );
      },
    },
    {
      field: "totalCost",
      headerName: "مجموع خرید",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.totalCost ? toMoney(cellValues.row.totalCost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "offerPercent",
      headerName: "درصد کمیسیون",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.offerPercent ? cellValues.row.offerPercent : 0}
          </Typography>
        );
      },
    },
    {
      field: "isActive",
      headerName: "وضعیت",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isActive ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.description,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/b2borders/editB2BOffer", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      id: cellValues.row.id,
                      search: props.search,
                      state: props.state,
                      panel: "offer",
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  return (
    <Accordion
      id="offer"
      expanded={props.expanded === "offer"}
      onChange={handleChange("offer")}
      style={{
        marginTop: "15px",
        paddingBottom: "15px",
        backgroundColor: "#e1e1e11c",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            آفرهای کیف پول
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ height: "30rem" }}>
        {offerRes ? (
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            rows={offerRes ? offerRes : []}
            page={pageState.page - 1}
            pageSize={20}
            Pagination
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...pageState, page: newPage + 1 }));
            }}
            rowCount={offerRes && offerRes.length ? offerRes.length : 1}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                newFunc: newFunc,
                scrollTo: myPc.scrollTo,
                rowCount: offerRes && offerRes.length ? offerRes.length : "",
                isLtr: true,
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "cost1",
                    sort: "asc",
                  },
                ],
              },
            }}
          />
        ) : (
          <ProgressCom></ProgressCom>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"آفر"}
          callback={() => {
            setProgress(true);
            deleteOffer(deleteState.id, () => {
              setProgress(true);
              getOffersList((offers) => {
                setOfferRes(offers);
              });
            });
          }}
        ></DeleteRow>
      </AccordionDetails>
    </Accordion>
  );
}
